<template>
  <v-app>
    <v-main>
      <!--
        Was <PublicNavBar />. No such component existed, so
        unplugin-vue-components left it unresolved and it rendered as nothing —
        every page on this layout, including all ~5,100 indexed /preview/:id
        pages, shipped with no header and no logo. AppBar is the nav the
        landing page already uses. <PublicFooter /> was missing for the same
        reason and is now a real component.
      -->
      <AppBar />
      <router-view />
      <PublicFooter />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
// Add any public layout logic here
</script>
